// src/services/api.js - shared service - duplicated from provider app, will want to remove most methods when have time

import { withAudit } from './auditMiddleware';
import { isDemoEnvironment } from '../config/platforms';

const XANO_BASE_URL = 'https://api.rehabilitationhealth.com/api:RIB0KqtX';
const XANO_TESTING_BASE_URL = 'https://test-api.rehabilitationhealth.com/api:RIB0KqtX';

// Veradigm token management
const VERADIGM_TOKEN_KEY = 'veradigm_token';
const VERADIGM_TIMESTAMP_KEY = 'veradigm_token_timestamp';
const VERADIGM_TOKEN_TIMEOUT_MS = 19 * 60 * 1000; // 19 minutes (1 min buffer)


class ApiService {
  constructor() {
    this.baseUrl = XANO_TESTING_BASE_URL;
  }

  async publicRequest(endpoint, options = {}) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        ...options.headers
      };

      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        ...options,
        headers
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('[API] Public request failed:', error);
      throw error;
    }
  }

  // Create our own request method with the correct base URL


  // Users Management
  async updateUser(userData) {

    const allSoftware = [
      ...Object.values(userData.software_used || {}).flat(),
      ...(userData.custom_software || [])
    ];

    return this.request('/user', {
      method: 'POST',
      body: JSON.stringify({
        first_name: userData.first_name || '',
        last_name: userData.last_name || '',
        role: userData.role,
        organization_id: userData.organization?.id || '',
        organization_name: userData.organization?.name || '',
        organization_type: userData.organization?.type || '',
        organization_size: userData.organization?.size || '',
        organization_address: {
          line1: userData.organization?.address?.line1 || '',
          line2: userData.organization?.address?.line2 || '',
          city: userData.organization?.address?.city || '',
          state: userData.organization?.address?.state || '',
          zip: userData.organization?.address?.zip || '',
          country: userData.organization?.address?.country || ''
        },
        phone: userData.phone || '',
        title: userData.title || '',
        notification_preferences: userData.notification_preferences || false,
        email_preferences: userData.email_preferences || false,
        onboarding: {
          is_completed: userData.onboarding?.is_completed || false,
          completed_steps: userData.onboarding?.completed_steps || '',
          last_step: userData.onboarding?.last_step || '',
          completed_at: userData.onboarding?.completed_at || null
        },
        name: `${userData.first_name} ${userData.last_name}`,
        ehr_system: userData.organization?.ehr_system || '',
        software_used: allSoftware,
        user_id: userData.id,
        vela_provider_id: userData.vela_provider_id,
        terms: userData.terms || {
          platform_terms: null,
          privacy_policy: null,
          security_agreement: null,
          solution_terms: {}
        },
        location: userData.location || {}
      })
    }, 'updateUser');
  }

  // New method for updating Vela provider
  async updateVelaProvider(userData, recordAction = 'U') {

    const allSoftware = [
      ...Object.values(userData.software_used || {}).flat(),
      ...(userData.custom_software || [])
    ];

    return this.request('/update_vela_provider', {
      method: 'POST',
      body: JSON.stringify({
        // Basic user info
        first_name: userData.first_name || '',
        middle_name: userData.middle_name || '',
        last_name: userData.last_name || '',
        suffix: userData.suffix || '',
        role: userData.role,
        vela_provider_id: userData.vela_provider_id,
        surescripts_provider_id: userData.surescripts_provider_id || '',
        record_action: recordAction,

        // Organization info
        organization_id: userData.organization?.id || '',
        organization: userData.organization || {},

        // Contact and personal info
        phone: userData.phone || '',
        title: userData.title || '',
        email: userData.email || '',

        // eRx specific fields
        erx_active: userData.erx_active,
        erx_active_date: userData.erx_active_date,
        erx_deactive_date: userData.erx_deactive_date,
        dea_number: userData.dea_number || '',
        dea_numbers: userData.dea_numbers || [],
        npi_number: userData.npi_number || '',
        supported_erx_services: userData.supported_erx_services || [],
        erx_pin: userData.erx_pin || '',
        identity_verified: userData.identity_verified || null,

        // Additional metadata
        notification_preferences: userData.notification_preferences || false,
        email_preferences: userData.email_preferences || false,
        sms_preferences: userData.sms_preferences || false,
        onboarding: {
          is_completed: userData.onboarding?.is_completed || false,
          completed_steps: userData.onboarding?.completed_steps || '',
          last_step: userData.onboarding?.last_step || '',
          completed_at: userData.onboarding?.completed_at || null
        },
        name: `${userData.first_name} ${userData.last_name}`,
        ehr_system: userData.organization?.ehr_system || '',
        software_used: allSoftware,
        user_id: userData.id,
        terms: userData.terms || {
          platform_terms: null,
          privacy_policy: null,
          security_agreement: null,
          solution_terms: {}
        },
        location: userData.location || {},
        medicare_provider_number: userData.medicare_provider_number || ''
      })
    }, 'updateVelaProvider');
  }
  //Method to update vela provider, different response type than updateVelaProvider
  async updateVelaUser(userData, recordAction = 'U') {

    const allSoftware = [
      ...Object.values(userData.software_used || {}).flat(),
      ...(userData.custom_software || [])
    ];

    return this.request('/update_vela_user', {
      method: 'POST',
      body: JSON.stringify({
        // Basic user info
        first_name: userData.first_name || '',
        middle_name: userData.middle_name || '',
        last_name: userData.last_name || '',
        suffix: userData.suffix || '',
        role: userData.role,
        vela_provider_id: userData.vela_provider_id,
        surescripts_provider_id: userData.surescripts_provider_id || '',
        record_action: recordAction,

        // Organization info
        organization_id: userData.organization?.id || '',
        organization: userData.organization || {},

        // Contact and personal info
        phone: userData.phone || '',
        title: userData.title || '',
        email: userData.email || '',

        // eRx specific fields
        erx_active: userData.erx_active,
        erx_active_date: userData.erx_active_date,
        erx_deactive_date: userData.erx_deactive_date,
        dea_number: userData.dea_number || '',
        dea_numbers: userData.dea_numbers || [],
        npi_number: userData.npi_number || '',
        supported_erx_services: userData.supported_erx_services || [],
        identity_verified: userData.identity_verified || null,
        // Additional metadata
        notification_preferences: userData.notification_preferences || false,
        email_preferences: userData.email_preferences || false,
        onboarding: {
          is_completed: userData.onboarding?.is_completed || false,
          completed_steps: userData.onboarding?.completed_steps || '',
          last_step: userData.onboarding?.last_step || '',
          completed_at: userData.onboarding?.completed_at || null
        },
        name: `${userData.first_name} ${userData.last_name}`,
        ehr_system: userData.organization?.ehr_system || '',
        software_used: allSoftware,
        user_id: userData.id,
        terms: userData.terms || {
          platform_terms: null,
          privacy_policy: null,
          security_agreement: null,
          solution_terms: {}
        },
        location: userData.location || {}
      })
    }, 'updateVelaProvider');
  }


  // get all users for an organization
  async getAllUsers(organizationId) {
    return this.request(`/user?organization_id=${organizationId}`, {
      method: 'GET'
    });
  }

  // add new user as a prescriber
  async addVelaProvider(userData) {
    return this.request('/add_vela_provider', {
      method: 'POST',
      body: JSON.stringify(userData)
    }, 'addVelaProvider');
  }

  // Patients
  async getAllPatients(organization_id) {
    return this.request(`/patient?organization_id=${organization_id}`, {
      method: 'GET'
    });
  }

  // Get a single patient by ID
  async getPatient(patientId) {
    return this.request(`/patient/${patientId}`, {
      method: 'GET'
    });
  }

  // Create a new patient
  async createPatient(patientData) {
    return this.request('/patient', {
      method: 'POST',
      body: JSON.stringify(patientData)
    });
  }

  // Update an existing patient
  async updatePatient(patientId, patientData) {
    return this.request(`/patient/${patientId}`, {
      method: 'PATCH',
      body: JSON.stringify(patientData)
    });
  }

  // Delete a patient
  async deletePatient(patientId) {
    return this.request(`/patient/${patientId}`, {
      method: 'DELETE'
    });
  }

  // Medications
  async searchMedications(searchText) {
    return this.request(`/get_prescribable_drugs?searchText=${encodeURIComponent(searchText)}`, {
      method: 'GET'
    });
  }
  // get most restrictive schedule
  async getMostRestrictiveSchedule(drugId, states) {
    const queryParams = new URLSearchParams();
    queryParams.append('drug_id', drugId);
    if (states) {
      queryParams.append('states', states);
    }

    return this.request(`/get_most_restrictive_schedule?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  // Pharmacy

  async getPharmacies() {
    return this.request('/pharmacy', {
      method: 'GET'
    });
  }

  async searchPharmacies(params) {
    const queryParams = new URLSearchParams();

    if (params.search_term) {
      queryParams.append('search_term', params.search_term);
    }

    if (params.patient_zip) {
      queryParams.append('patient_zip', params.patient_zip);
    }

    if (params.exact_match !== undefined) {
      queryParams.append('exact_match', params.exact_match ? 'true' : 'false');
    }

    const endpoint = `/search_pharmacies?${queryParams.toString()}`;
    return this.request(endpoint, {
      method: 'GET'
    });
  }

  // Get prescriber's recently used pharmacies
  async getPrescriberRecentPharmacies(userId) {
    return this.request(`/prescriber_recent_pharmacies?user_id=${userId}`, {
      method: 'GET'
    });
  }

  // Get specific pharmacy by NCPDP ID
  async getPharmacyByNcpdpId(ncpdpId) {
    return this.request(`/preferred_pharmacy?ncpdp_id=${ncpdpId}`, {
      method: 'GET'
    });
  }

  // Sigs

  // get sigs
  async getSigs(prescribableDrugId) {
    return this.request(`/get_sigs?drug_id=${encodeURIComponent(prescribableDrugId)}`, {
      method: 'GET'
    });
  }

  // get frequency and duration from typed sig
  async getSigData(instructions) {
    return this.request(`/extract_sig_data?instructions=${encodeURIComponent(instructions)}`, {
      method: 'GET'
    });
  }

  // Prescription

  async createPrescription(prescriptionData) {
    try {
      const response = await this.request('/test_prescription_signature', {
        method: 'POST',
        body: JSON.stringify(prescriptionData),
      }, 'transmitPrescription');

      // Check if this is a batch response (multiple medications)
      if (response.results && Array.isArray(response.results)) {
        // New batch response format
        return {
          status: response.status,
          message: response.message,
          results: response.results,
          summary: response.summary,
          rawResponse: response
        };
      }

      // Single medication response (legacy format)
      if (response.Status) {
        const statusInfo = getPrescriptionStatus(response);

        return {
          ...statusInfo,
          prescriptionId: response.prescription_id,
          rawResponse: response
        };
      }

      // If no recognizable response format, treat as error
      return {
        status: 'error',
        message: 'No response received from prescription service',
        isRetryable: true,
        severity: 'error',
        details: response
      };
    } catch (error) {
      console.error('Prescription creation error:', error);

      // Handle network or system errors
      return {
        status: 'error',
        message: 'Failed to send prescription. Please try again.',
        isRetryable: true,
        severity: 'error',
        details: error.message
      };
    }
  }
  // Get prescription history
  async getPrescriptionHistory(userId) {
    return this.request(`/prescription?user_id=${userId}`, {
      method: 'GET'
    });
  }
  // Get prescription detail
  async getPrescriptionDetail(prescriptionId) {
    return this.request(`/prescription/${prescriptionId}`, {
      method: 'GET'
    });
  }

  // Cancel prescription
  async cancelPrescription(cancelData, retryCount = 0) {
    const MAX_RETRIES = 2;
    const RETRY_DELAY = 1000; // 1 second delay between retries

    try {
      // Create a cancellation payload that includes any pharmacy_ncpdp_id if present
      const payload = {
        ...cancelData,
        // If a pharmacy_ncpdp_id was provided, include it explicitly
        ...(cancelData.pharmacy_ncpdp_id ? { pharmacy_ncpdp_id: cancelData.pharmacy_ncpdp_id } : {})
      };

      const response = await this.request('/prescription_cancel_request', {
        method: 'POST',
        body: JSON.stringify(payload)
      }, 'cancelPrescription');

      // Process the response to determine if we received an acknowledgment
      if (response.Status && (response.Status.Code === '000' || response.Status.Code === '010')) {
        return response;
      } else {
        // We received a response, but not a positive acknowledgment
        console.error('Cancel request not acknowledged:', response);

        // If we haven't reached max retries, try again
        if (retryCount < MAX_RETRIES) {
          await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
          return this.cancelPrescription(cancelData, retryCount + 1);
        }

        return {
          success: false,
          message: response.Status?.Description || 'Cancellation request failed.',
          rawResponse: response
        };
      }
    } catch (error) {
      console.error('Error sending cancel request:', error);

      // If we haven't reached max retries, try again
      if (retryCount < MAX_RETRIES) {
        await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
        return this.cancelPrescription(cancelData, retryCount + 1);
      }

      throw error;
    }
  }

  // Get change requests
  async getChangeRequests(userId) {
    return this.request(`/prescription_change_request?user_id=${userId}`, {
      method: 'GET'
    });
  }

  // Get change request detail - you would use this as a fallback if not passed from list view
  async getChangeRequestDetail(changeRequestId) {
    try {
      // First, try to get the specific change request detail
      return this.request(`/prescription_change_request/${changeRequestId}`, {
        method: 'GET'
      });
    } catch (error) {
      console.error('Error fetching change request detail:', error);

      // Fallback: fetch all change requests and find the matching one
      const allRequests = await this.getChangeRequests();
      const changeRequest = allRequests.find(req => req.id === changeRequestId);

      if (!changeRequest) {
        throw new Error('Change request not found');
      }

      return changeRequest;
    }
  }

  // Respond to a change request
  async respondToChangeRequest(responseData) {
    // Ensure the response includes the denial_reason_code if denying
    if (responseData.status === 'denied' && responseData.denial_reason_code) {
    }

    return this.request('/prescription_change_request', {
      method: 'POST',
      body: JSON.stringify(responseData)
    }, 'respondToChangeRequest');
  }

  // Get renewal requests
  async getRenewalRequests(userId) {
    return this.request(`/prescription_renewal_request?user_id=${userId}`, {
      method: 'GET'
    });
  }


  // Get details for a specific renewal request
  async getRenewalRequestDetail(renewalRequestId) {
    return this.request(`/prescription_renewal_request/${renewalRequestId}`, {
      method: 'GET'
    });
  }
  // Respond to renewal request
  async respondToRenewalRequest(response) {
    return this.request('/prescription_renewal_request', {
      method: 'POST',
      body: JSON.stringify(response)
    }, 'respondToRenewalRequest');
  }

  // Get renewal request count for notifications/badges
  async getPendingRenewalRequestCount(userId) {
    try {
      const renewalRequests = await this.getRenewalRequests(userId);
      return renewalRequests.filter(request => request.status === 'pending').length;
    } catch (error) {
      console.error('Error fetching pending renewal request count:', error);
      return 0;
    }
  }

  // Get change request count for notifications/badges
  async getPendingChangeRequestCount(userId) {
    try {
      const changeRequests = await this.getChangeRequests(userId);
      return changeRequests.filter(request => request.status === 'pending').length;
    } catch (error) {
      console.error('Error fetching pending renewal request count:', error);
      return 0;
    }
  }

  // Get cancel requests
  async getCancelRequests(userId) {
    return this.request(`/prescription_cancel_request?user_id=${userId}`, {
      method: 'GET'
    });
  }

  // Get prescriptions for a patient
  async getPrescriptions(patientId) {
    return this.request(
      `/prescriptions/patient?patient_id=${patientId}`,
      { method: 'GET' }
    );
  }

  // Veradigm API methods to add to ApiService class
  async getVeradigmToken() {
    // Check for valid existing token
    const token = localStorage.getItem(VERADIGM_TOKEN_KEY);
    const timestamp = localStorage.getItem(VERADIGM_TIMESTAMP_KEY);
    const now = Date.now();

    if (token && timestamp && now - parseInt(timestamp, 10) < VERADIGM_TOKEN_TIMEOUT_MS) {
      return token;
    }

    // Otherwise, get new token from Xano
    try {
      const response = await this.request('/veradigm/get-token', {
        method: 'GET'
      });

      if (!response.success || !response.token) {
        throw new Error(response.error || 'Failed to get Veradigm token');
      }

      // Store token and timestamp
      localStorage.setItem(VERADIGM_TOKEN_KEY, response.token);
      localStorage.setItem(VERADIGM_TIMESTAMP_KEY, now.toString());

      return response.token;
    } catch (error) {
      console.error('[API] Error getting Veradigm token:', error);
      throw error;
    }
  }

  async authenticateVeradigmUser(ehrUsername, password) {
    const token = await this.getVeradigmToken();

    return this.request('/veradigm/magic', {
      method: 'POST',
      body: JSON.stringify({
        action: 'GetUserAuthentication',
        patientId: '',
        token,
        ehrUser: ehrUsername,
        param1: password,
        param2: '',
        param3: '',
        param4: '',
        param5: '',
        param6: '',
        data: ''
      })
    });
  }

  async callVeradigmAction(action, patientId = '', params = {}, ehrUser = 'jmedici') {
    try {
      // Get token and update activity timestamp
      const token = await this.getVeradigmToken();
      localStorage.setItem(VERADIGM_TIMESTAMP_KEY, Date.now().toString());

      // Build request
      return this.request('/veradigm/magic', {
        method: 'POST',
        body: JSON.stringify({
          action,
          patientId,
          token,
          ehrUser,
          param1: params.param1 || '',
          param2: params.param2 || '',
          param3: params.param3 || '',
          param4: params.param4 || '',
          param5: params.param5 || '',
          param6: params.param6 || '',
          data: params.data || ''
        })
      });
    } catch (error) {
      console.error(`[API] Error calling Veradigm ${action}:`, error);

      // Check for token errors
      if (error.message && (
        error.message.includes('token') ||
        error.message.includes('Token') ||
        error.message.includes('authentication') ||
        error.message.includes('Authentication')
      )) {
        // Clear token on auth errors
        localStorage.removeItem(VERADIGM_TOKEN_KEY);
        localStorage.removeItem(VERADIGM_TIMESTAMP_KEY);
      }

      throw error;
    }
  }

  // Common Veradigm operations - add as needed
  async getVeradigmServerInfo(ehrUser = 'jmedici') {
    return this.callVeradigmAction('GetServerInfo', '', {}, ehrUser);
  }

  async searchVeradigmPatients(searchTerm, ehrUser = 'jmedici') {
    return this.callVeradigmAction('SearchPatients', '', { param1: searchTerm }, ehrUser);
  }

  async getVeradigmPatient(patientId, ehrUser = 'jmedici') {
    return this.callVeradigmAction('GetPatient', patientId, {}, ehrUser);
  }

  // Clear Veradigm token (call on logout)
  clearVeradigmToken() {
    localStorage.removeItem(VERADIGM_TOKEN_KEY);
    localStorage.removeItem(VERADIGM_TIMESTAMP_KEY);
  }

  // Favorites management
  async getFavoriteMedications(userId) {
    if (!userId) return [];

    return this.request(`/favorite_medications?user_id=${userId}`, {
      method: 'GET'
    });
  }

  // Add a medication to favorites (with complete medication data)
  async addFavoriteMedication(userId, medicationId, medicationData) {
    return this.request('/favorite_medications', {
      method: 'POST',
      body: JSON.stringify({
        user_id: userId,
        medication_id: medicationId,
        medication_data: medicationData // Store the complete medication object
      })
    });
  }

  // Remove a medication from favorites
  async removeFavoriteMedication(userId, medicationId) {
    return this.request(`/favorite_medications`, {
      method: 'DELETE',
      body: JSON.stringify({
        user_id: userId,
        medication_id: medicationId
      })
    });
  }

  // Check if a medication is in favorites
  async isFavoriteMedication(userId, medicationId) {

    try {
      const favorites = await this.getFavoriteMedications(userId);
      const isFavorite = favorites.some(fav => fav.medication_id === medicationId);
      return isFavorite;
    } catch (error) {
      console.error('❌ API: Error checking favorite status:', error);
      throw error;
    }
  }

  //Veradigm
  // Veradigm Integration
  async initiateVeradigmAuth(userId) {
    try {
      const response = await this.request('/veradigm/initiate-auth', {
        method: 'POST',
        body: JSON.stringify({ user_id: userId })
      });
      return response;
    } catch (error) {
      console.error('Error initiating Veradigm auth:', error);
      throw error;
    }
  }

  async completeVeradigmAuth(userId, code, state) {
    try {
      const response = await this.request('/veradigm/callback', {
        method: 'POST',
        body: JSON.stringify({
          user_id: userId,
          code,
          state
        })
      });
      return response;
    } catch (error) {
      console.error('Error completing Veradigm auth:', error);
      throw error;
    }
  }

  async checkVeradigmConnection(userId) {
    try {
      const response = await this.request(`/veradigm/connection-status?user_id=${userId}`, {
        method: 'GET'
      });
      return response;
    } catch (error) {
      console.error('Error checking Veradigm connection:', error);
      throw error;
    }
  }

  async getUserSolution(organizationId, solutionId, userId) {
    return this.request(`/user_solution?organization_id=${organizationId}&solution_id=${solutionId}&user_id=${userId}`, {
      method: 'GET'
    });
  }

  async getUserPublic(userId) {
    return this.publicRequest(`/user${userId}/public`, {
      method: 'GET'
    });
  }

  // Get users including Veradigm providers
  async getUsers(organizationId, userId) {
    return this.request(`/erx/user?organization_id=${organizationId}&user_id=${userId}`, {
      method: 'GET'
    });
  }

  async getOrganizationUsers(organizationId) {
    return this.request(`/user?organization_id=${organizationId}`, {
      method: 'GET'
    });
  }

  async getOrganizationUsersPublic(organizationId) {
    return this.publicRequest(`/users/public?organization_id=${organizationId}`, {
      method: 'GET'
    });
  }

  // Get patients from Veradigm
  async getVeradigmPatients(userId, organizationId, letter) {
    return this.request(`/veradigm/patients?user_id=${userId}&organization_id=${organizationId}&letter=${letter}`, {
      method: 'GET'
    });
  }

  //Audit logging endpoints
  async createAuditLogEntry(data) {
    const eventData = {
      user_id: data.userId,
      organization_id: data.organizationId || data.organization_id || null,
      event_type: data.eventType,
      event_date: data.eventDate || new Date().toISOString(),
      description: data.description,
      outcome: data.outcome || 'success',
      prescription_id: data.prescriptionId || null,
      patient_id: data.patientId || null,
      medication_id: data.medicationId || null,
      ip_address: data.ipAddress || null,
      additional_data: data.additionalData || {}
    };

    return this.request('/erx_mobile_audit_logs', {
      method: 'POST',
      body: JSON.stringify(eventData)
    });
  }

  async getAuditLogs(filters = {}) {
    const queryParams = new URLSearchParams();

    // Add all filter parameters
    if (filters.userId) queryParams.append('user_id', filters.userId);
    if (filters.organizationId) queryParams.append('organization_id', filters.organizationId);
    if (filters.startDate) queryParams.append('start_date', filters.startDate);
    if (filters.endDate) queryParams.append('end_date', filters.endDate);
    if (filters.eventType) queryParams.append('event_type', filters.eventType);
    if (filters.prescriptionId) queryParams.append('prescription_id', filters.prescriptionId);
    if (filters.patientId) queryParams.append('patient_id', filters.patientId);
    if (filters.medicationId) queryParams.append('medication_id', filters.medicationId);
    if (filters.outcome) queryParams.append('outcome', filters.outcome);
    if (filters.search) queryParams.append('search', filters.search);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);

    return this.request(`/erx_mobile_audit_logs?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async generateControlledSubstanceReport(userId, startDate, endDate, format = 'json') {
    const queryParams = new URLSearchParams();
    queryParams.append('user_id', userId);
    queryParams.append('start_date', startDate);
    queryParams.append('end_date', endDate);
    queryParams.append('format', format);
    queryParams.append('controlled_substances_only', 'true');

    return this.request(`/prescription_report?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getMonthlyControlledSubstanceLog(userId, year, month, format = 'json') {
    const queryParams = new URLSearchParams();
    queryParams.append('user_id', userId);
    queryParams.append('year', year);
    queryParams.append('month', month);
    queryParams.append('format', format);
    queryParams.append('controlled_substances_only', 'true');

    return this.request(`/monthly_prescription_log?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getDailyAuditReport(date = new Date().toISOString().split('T')[0]) {
    return this.request(`/audit_log/daily_report?date=${date}`, {
      method: 'GET'
    });
  }

  async getSecurityReport(organizationId, startDate, endDate) {
    const queryParams = new URLSearchParams();
    queryParams.append('organization_id', organizationId);
    queryParams.append('start_date', startDate);
    queryParams.append('end_date', endDate);

    return this.request(`/audit_log/security_report?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getControlledSubstanceReport(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.userId) queryParams.append('user_id', filters.userId);
    if (filters.organizationId) queryParams.append('organization_id', filters.organizationId);
    if (filters.startDate) queryParams.append('start_date', filters.startDate);
    if (filters.endDate) queryParams.append('end_date', filters.endDate);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    if (filters.sortField) queryParams.append('sort_field', filters.sortField);
    if (filters.sortDirection) queryParams.append('sort_direction', filters.sortDirection);
    if (filters.schedule) queryParams.append('schedule', filters.schedule);

    return this.request(`/controlled_substance_report?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async verifyPin(userId, pin) {
    return this.request('/erx/verify-pin', {
      method: 'POST',
      body: JSON.stringify({ user_id: userId, pin })
    }, 'verifyPin');
  }

  async searchExercises(params) {
    const queryParams = new URLSearchParams();

    // Add all search parameters
    if (params.q) queryParams.append('q', params.q);
    if (params.body_part) {
      if (Array.isArray(params.body_part)) {
        params.body_part.forEach(bp => queryParams.append('body_part[]', bp));
      } else {
        queryParams.append('body_part', params.body_part);
      }
    }
    if (params.exercise_type) {
      if (Array.isArray(params.exercise_type)) {
        params.exercise_type.forEach(ty => queryParams.append('exercise_type[]', ty));
      } else {
        queryParams.append('exercise_type', params.exercise_type);
      }
    }
    if (params.equipment) {
      if (Array.isArray(params.equipment)) {
        params.equipment.forEach(eq => queryParams.append('equipment[]', eq));
      } else {
        queryParams.append('equipment', params.equipment);
      }
    }
    if (params.cpg_tags) {
      if (Array.isArray(params.cpg_tags)) {
        params.cpg_tags.forEach(cp => queryParams.append('cpg_tags[]', cp));
      } else {
        queryParams.append('cpg_tags', params.cpg_tags);
      }
    }
    if (params.motion) {
      if (Array.isArray(params.motion)) {
        params.motion.forEach(mt => queryParams.append('motion[]', mt));
      } else {
        queryParams.append('motion', params.motion);
      }
    }
    if (params.exercise_ids) {
      if (Array.isArray(params.exercise_ids)) {
        params.exercise_ids.forEach(ei => queryParams.append('exercise_ids[]', ei));
      } else {
        queryParams.append('exercise_ids', params.exercise_ids);
      }
    }
    if (params.difficulty_min) queryParams.append('difficulty_min', params.difficulty_min);
    if (params.difficulty_max) queryParams.append('difficulty_max', params.difficulty_max);
    if (params.favorites_only) queryParams.append('favorites_only', params.favorites_only);
    if (params.suitable_for) queryParams.append('suitable_for', params.suitable_for);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);

    return this.request(`/exercises/search?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getExerciseFilters() {
    return this.request('/exercises/filters', {
      method: 'GET'
    });
  }

  async getExercise(id) {
    return this.request(`/exercise/${id}`, {
      method: 'GET'
    });
  }

  // Favorite endpoints
  async getFavoriteExercises() {
    return this.request('/user_favorite_exercises', {
      method: 'GET'
    });
  }

  async addFavoriteExercise(exerciseId) {
    return this.request('/user_favorite_exercises', {
      method: 'POST',
      body: JSON.stringify({ exercise_id: exerciseId })
    });
  }

  async removeFavoriteExercise(exerciseId) {
    return this.request(`/user_favorite_exercises/${parseInt(exerciseId)}`, {
      method: 'DELETE'
    });
  }

  // Exercise prescription endpoints (for later)
  async createExercisePrescription(data) {
    // If data is already in the correct format (has modules or exercises at root level),
    // pass it through as is
    if (data.modules !== undefined || data.exercises !== undefined) {
      return this.request('/exercise_prescription', {
        method: 'POST',
        body: JSON.stringify(data)
      });
    }

    // Otherwise, transform the data from the RoutineBuilder format
    const prescriptionData = {
      patient_id: data.patient_id,
      provider_id: data.provider_id,
      organization_id: data.organization_id,
      name: data.name,
      description: data.description,
      prescription_type: data.prescription_type,
      start_date: new Date().toISOString().split('T')[0],
      status: data.status || 'active',
      is_template: data.is_template || false,
      template_visibility: data.template_visibility || 'private',

      // Schedule mapping
      schedule: {
        rehab_frequency: data.prescription_type === 'rehabilitation' ? {
          times_per_week: data.schedule.frequency === '3x_week' ? 3 :
            data.schedule.frequency === '5x_week' ? 5 : 7,
          times_per_day: 1
        } : undefined,
        workout_schedule: data.prescription_type === 'fitness' ? {
          monday: data.schedule.frequency !== 'daily' ? 'rest' : 'workout',
          tuesday: 'workout',
          wednesday: data.schedule.frequency === '3x_week' ? 'rest' : 'workout',
          thursday: 'workout',
          friday: data.schedule.frequency === '3x_week' ? 'rest' : 'workout',
          saturday: data.schedule.frequency === '5x_week' ? 'rest' : 'workout',
          sunday: 'rest'
        } : undefined
      },

      // For rehabilitation - flat exercise list
      exercises: data.prescription_type === 'rehabilitation' && data.exercises ?
        data.exercises.map((ex, index) => ({
          exercise_id: ex.id,
          sequence: index + 1,
          parameters: {
            sets: ex.parameters?.sets || '',
            reps: ex.parameters?.reps || '',
            hold_time: ex.parameters?.hold_time || '',
            frequency: ex.parameters?.frequency || '',
            weight: ex.parameters?.weight || '',
            instructions: ex.parameters?.instructions || '',
            precautions: ex.precautions || []
          },
          is_active: true
        })) : [],

      // For fitness - modular structure
      modules: data.prescription_type === 'fitness' && data.modules ?
        data.modules.map((module, moduleIndex) => ({
          module_id: module.id,
          module_type: module.id,
          module_name: module.name,
          sequence: moduleIndex + 1,
          exercises: module.exercises.map((ex, exIndex) => ({
            exercise_id: ex.id,
            sequence: exIndex + 1,
            group_id: data.exercise_groups && Object.values(data.exercise_groups)
              .find(group => group.exerciseIds.includes(ex.uniqueId))?.id,
            parameters: {
              sets: ex.parameters?.sets || '',
              reps: ex.parameters?.reps || '',
              rest_time: ex.parameters?.rest_time || '',
              weight: ex.parameters?.weight || '',
              instructions: ex.parameters?.instructions || '',
              track_weight: true,
              track_pain: false
            }
          }))
        })) : [],

      // Exercise groups (for fitness)
      exercise_groups: data.exercise_groups ? Object.values(data.exercise_groups).map(group => ({
        group_id: group.id,
        group_type: group.type,
        name: group.name,
        instructions: group.instructions || '',
        rest_between_rounds: group.restBetweenRounds,
        rounds: group.rounds
      })) : []
    };

    return this.request('/exercise_prescription', {
      method: 'POST',
      body: JSON.stringify(prescriptionData)
    });
  }


  async updateExercisePrescription(id, data) {
    return this.request(`/exercise_prescription/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async getExercisePrescriptions(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.provider_id) queryParams.append('provider_id', filters.provider_id);
    if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
    if (filters.prescription_type) queryParams.append('prescription_type', filters.prescription_type);
    if (filters.status) queryParams.append('status', filters.status);

    return this.request(`/exercise_prescription?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async duplicateExercisePrescription(prescriptionId) {
    return this.request(`/exercise_prescription/${prescriptionId}/duplicate`, {
      method: 'POST'
    });
  }

  async getExercisePrescription(id) {
    return this.request(`/exercise_prescription/${id}`, {
      method: 'GET'
    });
  }

  async deleteExercisePrescription(id) {
    return this.request(`/exercise_prescription/${id}`, {
      method: 'DELETE'
    });
  }


  async getExercisesByIds(exerciseIds) {
    if (!exerciseIds || exerciseIds.length === 0) {
      return [];
    }

    let ids = exerciseIds.join(",");

    try {
      // Call the batch endpoint
      const response = await this.request(`/exercises/get-batch?exercise_ids=${ids}`, {
        method: 'GET'
      });

      // Handle empty or invalid responses
      if (!response || !Array.isArray(response)) {
        console.error('Invalid response from get-batch:', response);
        return [];
      }

      return response;
    } catch (error) {
      console.error('Failed to fetch exercises by IDs:', error);
      return [];
    }
  }

  // ============ Workout Plans ============

  // Workout Plan CRUD
  async createWorkoutPlan(data) {
    return this.request('/workout_plan', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getWorkoutPlans(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
    if (filters.created_by) queryParams.append('created_by', filters.created_by);
    if (filters.is_template !== undefined) queryParams.append('is_template', filters.is_template);
    if (filters.template_visibility) queryParams.append('template_visibility', filters.template_visibility);
    if (filters.plan_type) queryParams.append('plan_type', filters.plan_type);
    if (filters.templates_page) queryParams.append('templates_page', filters.templates_page);

    return this.request(`/workout_plan?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getWorkoutPlan(id) {
    return this.request(`/workout_plan/${id}`, {
      method: 'GET'
    });
  }

  async updateWorkoutPlan(id, data) {
    return this.request(`/workout_plan/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteWorkoutPlan(id) {
    return this.request(`/workout_plan/${id}`, {
      method: 'DELETE'
    });
  }

  // Workout Plan Week CRUD
  async createWorkoutPlanWeek(data) {
    return this.request('/workout_plan_week', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getWorkoutPlanWeeks(workoutPlanId) {
    return this.request(`/workout_plan_week?workout_plan_id=${workoutPlanId}`, {
      method: 'GET'
    });
  }

  async updateWorkoutPlanWeek(id, data) {
    return this.request(`/workout_plan_week/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteWorkoutPlanWeek(id) {
    return this.request(`/workout_plan_week/${id}`, {
      method: 'DELETE'
    });
  }

  // Workout Plan Schedule CRUD
  async createWorkoutPlanSchedule(data) {
    return this.request('/workout_plan_schedule', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getWorkoutPlanSchedules(workoutPlanWeekId) {
    return this.request(`/workout_plan_schedule?workout_plan_week_id=${workoutPlanWeekId}`, {
      method: 'GET'
    });
  }

  async updateWorkoutPlanSchedule(id, data) {
    return this.request(`/workout_plan_schedule/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteWorkoutPlanSchedule(id) {
    return this.request(`/workout_plan_schedule/${id}`, {
      method: 'DELETE'
    });
  }

  // ============ Rehab Programs ============

  // Rehab Program CRUD
  async createRehabProgram(data) {
    return this.request('/rehab_program', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getRehabPrograms(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
    if (filters.created_by) queryParams.append('created_by', filters.created_by);
    if (filters.is_template !== undefined) queryParams.append('is_template', filters.is_template);
    if (filters.template_visibility) queryParams.append('template_visibility', filters.template_visibility);
    if (filters.condition) queryParams.append('condition', filters.condition);
    if (filters.templates_page) queryParams.append('templates_page', filters.templates_page);

    return this.request(`/rehab_program?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getRehabProgram(id) {
    return this.request(`/rehab_program/${id}`, {
      method: 'GET'
    });
  }

  async updateRehabProgram(id, data) {
    return this.request(`/rehab_program/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteRehabProgram(id) {
    return this.request(`/rehab_program/${id}`, {
      method: 'DELETE'
    });
  }

  // Rehab Program Phase CRUD
  async createRehabProgramPhase(data) {
    return this.request('/rehab_program_phase', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getRehabProgramPhases(rehabProgramId) {
    return this.request(`/rehab_program_phase?rehab_program_id=${rehabProgramId}`, {
      method: 'GET'
    });
  }

  async updateRehabProgramPhase(id, data) {
    return this.request(`/rehab_program_phase/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteRehabProgramPhase(id) {
    return this.request(`/rehab_program_phase/${id}`, {
      method: 'DELETE'
    });
  }

  // Rehab Program Prescription CRUD
  async createRehabProgramPrescription(data) {
    return this.request('/rehab_program_prescription', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getRehabProgramPrescriptions(rehabProgramPhaseId) {
    return this.request(`/rehab_program_prescription?rehab_program_phase_id=${rehabProgramPhaseId}`, {
      method: 'GET'
    });
  }

  async updateRehabProgramPrescription(id, data) {
    return this.request(`/rehab_program_prescription/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteRehabProgramPrescription(id) {
    return this.request(`/rehab_program_prescription/${id}`, {
      method: 'DELETE'
    });
  }

  // ============ Patient Exercise Assignment ============

  async createPatientExerciseAssignment(data) {
    return this.request('/patient_exercise_assignment', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getPatientExerciseAssignments(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.provider_id) queryParams.append('provider_id', filters.provider_id);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.assignment_type) queryParams.append('assignment_type', filters.assignment_type);
    if (filters.rehab_program_id) queryParams.append('rehab_program_id', filters.rehab_program_id);
    if (filters.workout_plan_id) queryParams.append('workout_plan_id', filters.workout_plan_id);

    return this.request(`/patient_exercise_assignment?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getPatientExerciseAssignment(id) {
    return this.request(`/patient_exercise_assignment/${id}`, {
      method: 'GET'
    });
  }

  async updatePatientExerciseAssignment(id, data) {
    return this.request(`/patient_exercise_assignment/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deletePatientExerciseAssignment(id) {
    return this.request(`/patient_exercise_assignment/${id}`, {
      method: 'DELETE'
    });
  }

  // ============ Helper Methods for Complex Operations ============

  // Create a rehab program from a single prescription
  async createRehabProgramFromPrescription(prescriptionData, programData) {
    try {
      // 1. Create the exercise prescription
      const prescription = await this.createExercisePrescription(prescriptionData);

      // 2. Create the rehab program
      const program = await this.createRehabProgram({
        name: programData.name,
        description: programData.description || prescriptionData.description,
        condition: programData.condition,
        total_phases: 1,
        expected_duration_weeks: programData.duration_weeks || 4,
        created_by: prescriptionData.provider_id,
        organization_id: prescriptionData.organization_id,
        is_template: programData.is_template || false,
        template_visibility: programData.template_visibility || 'private'
      });

      // 3. Create the phase
      const phase = await this.createRehabProgramPhase({
        rehab_program_id: program.id,
        phase_number: 1,
        phase_name: programData.phase_name || 'Phase 1',
        duration_weeks: programData.duration_weeks || 4,
        goals: programData.goals || [],
        criteria_for_progression: programData.criteria_for_progression || ''
      });

      // 4. Link prescription to phase
      await this.createRehabProgramPrescription({
        rehab_program_phase_id: phase.id,
        exercise_prescription_id: prescription.id,
        frequency_per_week: prescriptionData.schedule?.rehab_frequency?.times_per_week || 3,
        sequence: 1
      });

      return {
        program,
        phase,
        prescription
      };
    } catch (error) {
      console.error('Failed to create rehab program from prescription:', error);
      throw error;
    }
  }

  // Get complete workout plan with weeks and schedules
  async getCompleteWorkoutPlan(id) {
    try {
      // 1. Get the base plan
      const plan = await this.getWorkoutPlan(id);

      // 2. Get all weeks for this plan
      const weeksResponse = await this.getWorkoutPlanWeeks(id);
      const weeks = weeksResponse || [];

      // 3. Get schedules for each week and prescriptions
      const weeksWithSchedules = await Promise.all(
        weeks.map(async (week) => {
          const schedulesResponse = await this.getWorkoutPlanSchedules(week.id);
          const schedules = schedulesResponse || [];

          // 4. Get prescription details for each schedule
          const schedulesWithPrescriptions = await Promise.all(
            schedules.map(async (schedule) => {
              try {
                const prescription = await this.getExercisePrescription(schedule.exercise_prescription_id);
                return {
                  ...schedule,
                  prescription
                };
              } catch (error) {
                console.error('Failed to fetch prescription:', error);
                return schedule;
              }
            })
          );

          return {
            ...week,
            schedules: schedulesWithPrescriptions
          };
        })
      );

      // 5. Get assignment count
      const assignmentsResponse = await this.getPatientExerciseAssignments({
        workout_plan_id: id,
        status: 'active'
      });

      return {
        ...plan,
        weeks: weeksWithSchedules.sort((a, b) => a.week_number - b.week_number),
        assignment_count: assignmentsResponse.length || 0
      };
    } catch (error) {
      console.error('Failed to get complete workout plan:', error);
      throw error;
    }
  }

  // Get complete rehab program with phases and prescriptions
  async getCompleteRehabProgram(rehabProgramId) {
    try {
      const program = await this.getRehabProgram(rehabProgramId);
      const phases = await this.getRehabProgramPhases(rehabProgramId);

      // Get prescriptions for each phase
      const phasesWithPrescriptions = await Promise.all(
        phases.map(async (phase) => {
          const prescriptions = await this.getRehabProgramPrescriptions(phase.id);
          return { ...phase, prescriptions };
        })
      );

      return {
        ...program,
        phases: phasesWithPrescriptions
      };
    } catch (error) {
      console.error('Failed to get complete rehab program:', error);
      throw error;
    }
  }

  async createWorkoutPlanFromPrescription(prescriptionData, planData, workoutSchedule = null) {
    try {
      // 1. Create the exercise prescription
      const prescription = await this.createExercisePrescription(prescriptionData);

      // 2. Create the workout plan
      const plan = await this.createWorkoutPlan({
        name: planData.name,
        description: planData.description || prescriptionData.description,
        plan_type: planData.planType || 'general',
        fitness_level: planData.fitnessLevel || 'intermediate',
        duration_weeks: planData.duration_weeks || 4,
        created_by: prescriptionData.provider_id,
        organization_id: prescriptionData.organization_id,
        is_template: planData.is_template || false,
        template_visibility: planData.template_visibility || 'private'
      });

      // 3. Create weeks
      const weeks = [];
      for (let i = 1; i <= planData.duration_weeks; i++) {
        const week = await this.createWorkoutPlanWeek({
          workout_plan_id: plan.id,
          week_number: i,
          notes: ''
        });
        weeks.push(week);
      }

      // 4. Assign workout to days based on provided schedule or defaults
      if (workoutSchedule) {
        // Use the custom schedule from UI
        for (const week of weeks) {
          const weekSchedule = workoutSchedule[week.week_number] || [];
          let sequence = 1;

          for (const dayOfWeek of weekSchedule) {
            await this.createWorkoutPlanSchedule({
              workout_plan_week_id: week.id,
              exercise_prescription_id: prescription.id,
              day_of_week: dayOfWeek,
              is_optional: false,
              sequence: sequence++
            });
          }
        }
      } else {
        // Fall back to default frequency-based assignment
        const daysPerWeek = this.getDaysFromFrequency(
          prescriptionData.schedule?.workout_schedule?.frequency || '3x_week'
        );

        for (const week of weeks) {
          let sequence = 1;
          for (const dayOfWeek of daysPerWeek) {
            await this.createWorkoutPlanSchedule({
              workout_plan_week_id: week.id,
              exercise_prescription_id: prescription.id,
              day_of_week: dayOfWeek,
              is_optional: false,
              sequence: sequence++
            });
          }
        }
      }

      return { plan, weeks, prescription };
    } catch (error) {
      console.error('Failed to create workout plan from prescription:', error);
      throw error;
    }
  }

  // Helper to convert frequency to specific days
  getDaysFromFrequency(frequency) {
    const dayMappings = {
      'daily': [1, 2, 3, 4, 5, 6, 7],
      '2x_week': [2, 5], // Tuesday, Friday
      '3x_week': [1, 3, 5], // Monday, Wednesday, Friday
      '4x_week': [1, 2, 4, 5], // Mon, Tue, Thu, Fri
      '5x_week': [1, 2, 3, 4, 5], // Weekdays
      '6x_week': [1, 2, 3, 4, 5, 6], // Mon-Sat
      'custom': [] // Will need to handle separately
    };

    return dayMappings[frequency] || dayMappings['3x_week'];
  }

  // Form Builder Related Endpoints

  // Forms
  async getFormDefinitions(organizationId, locationId = null, type = null) {
    let endpoint = `/forms?organization_id=${organizationId}`;
    if (locationId) endpoint += `&location_id=${locationId}`;
    if (type) endpoint += `&type=${type}`;

    return this.request(endpoint, { method: 'GET' });
  }

  async getFormDefinition(formId) {
    return this.request(`/forms/${formId}`, { method: 'GET' });
  }

  async createFormDefinition(formData) {
    return this.request('/forms', {
      method: 'POST',
      body: JSON.stringify(formData)
    });
  }

  async updateFormDefinition(formId, formData) {
    return this.request(`/forms/${formId}`, {
      method: 'PATCH',
      body: JSON.stringify(formData)
    });
  }

  async deleteFormDefinition(formId) {
    return this.request(`/forms/${formId}`, { method: 'DELETE' });
  }

  // Form Versions
  async getFormVersions(formId) {
    return this.request(`/forms-versions?form_id=${formId}`, { method: 'GET' });
  }

  async getFormVersion(versionId) {
    return this.request(`/form-versions/${versionId}`, { method: 'GET' });
  }

  async createFormVersion(versionData) {
    return this.request('/form-versions', {
      method: 'POST',
      body: JSON.stringify(versionData)
    });
  }

  // Form Publishing
  async updateFormDefinitionWithPublishing(formId, formData, publish = false, customSlug = null) {
    if (publish && customSlug) {
      const isValidSlug = await this.validateSlug(customSlug);
      if (!isValidSlug) {
        throw new Error('Invalid or duplicate slug');
      }
    }

    let updatedFormData = { ...formData };

    if (publish) {
      const publishedUrl = await this.generatePublishedUrl(formId, customSlug);
      updatedFormData = {
        ...updatedFormData,
        status: 'published',
        published_url: publishedUrl
      };

      if (customSlug) {
        updatedFormData.slug = customSlug;
      }
    }

    return this.updateFormDefinition(formId, updatedFormData);
  }

  async generatePublishedUrl(formId, customSlug = null) {
    const formBaseDomain = 'https://forms.rehabilitationhealth.com/';
    const urlPath = customSlug || formId;
    return `${formBaseDomain}${urlPath}`;
  }

  async getExistingFormSlugs() {
    try {
      return await this.request('/form-url-slugs', { method: 'GET' });
    } catch (error) {
      console.error('[API] Failed to fetch existing slugs:', error);
      return [];
    }
  }

  async validateSlug(slug) {
    if (!slug) return false;

    const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
    if (!slugRegex.test(slug)) {
      return false;
    }

    const existingSlugs = await this.getExistingFormSlugs();
    return !existingSlugs.includes(slug);
  }

  // Form Assignment
  async assignFormToLocation(locationId, formId, formType) {
    return this.request('/form-assignments', {
      method: 'POST',
      body: JSON.stringify({
        form_id: formId,
        type: formType,
        location_id: locationId
      })
    });
  }

  // Form Responses
  async getFormResponses(formId = null, organizationId = null, locationId = null, startDate = null, endDate = null, page = 1, perPage = 25) {
    let endpoint = `/form-responses-with-pagination?page=${page}&per_page=${perPage}`;
    const params = [];

    if (formId) params.push(`form_id=${formId}`);
    if (organizationId) params.push(`organization_id=${organizationId}`);
    if (locationId) params.push(`location_id=${locationId}`);
    if (startDate) params.push(`start_date=${startDate}`);
    if (endDate) params.push(`end_date=${endDate}`);

    if (params.length > 0) {
      endpoint += `&${params.join('&')}`;
    }

    return this.request(endpoint, { method: 'GET' });
  }

  async getFormResponse(responseId) {
    return this.request(`/form-responses/${responseId}`, { method: 'GET' });
  }

  async getFormResponseBySession(sessionToken) {
    try {
      return await this.publicRequest(`/public/form-responses?session_token=${sessionToken}`);
    } catch (error) {
      console.error('[API] Failed to fetch form response by session:', error);
      return null;
    }
  }

  async updateFormResponse(responseId, responseData) {
    return this.request(`/form-responses/${responseId}`, {
      method: 'PATCH',
      body: JSON.stringify(responseData)
    });
  }

  async updateScheduleResponse(responseId, responseData, providerChanged, notifyProvider, markScheduled) {
    return this.request(`/form-responses/${responseId}/scheduling-update`, {
      method: 'PATCH',
      body: JSON.stringify({
        provider_changed: providerChanged,
        notify_provider: notifyProvider,
        mark_scheduled: markScheduled,
        ...responseData
      })
    });
  }

  // Form Generated Reports
  async getFormGeneratedReports(organizationId, locationId = null, page = 1, perPage = 25) {
    let endpoint = `/form-generated-reports-with-pagination?organization_id=${organizationId}&page=${page}&per_page=${perPage}`;
    if (locationId) {
      endpoint += `&location_id=${locationId}`;
    }

    return this.request(endpoint, { method: 'GET' });
  }

  async getFormGeneratedReportById(id) {
    return this.request(`/form-generated-reports/${id}`, { method: 'GET' });
  }

  async updateReportDownloadStatus(reportId, report) {
    return this.request(`/form-generated-reports/${reportId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        ...report,
        downloaded: true
      })
    });
  }

  // Generate a signed URL for downloading an attachment
  async getAttachmentDownloadUrl(path) {
    // In demo environment, the path is already a public URL
    if (isDemoEnvironment()) {
      return path;
    }
    
    // In production, make the API request for private file access
    try {
      const response = await this.request(`/attachment/download-url?path=${path}&ttl=1800`);
      return response;
    } catch (error) {
      console.error('[API] Failed to generate download URL:', error);
      throw new Error('Failed to generate download URL');
    }
  }

  async downloadAttachment(attachment) {
    try {
      let downloadUrl;
      
      // Determine the attachment path/URL
      const attachmentPath = attachment.path || attachment.url || attachment.file_url;
      
      if (!attachmentPath) {
        throw new Error('No download path available for attachment');
      }
      
      // In demo environment with a direct URL available, use it
      if (isDemoEnvironment() && (attachment.url || attachment.file_url)) {
        downloadUrl = attachment.url || attachment.file_url;
      } else {
        // Otherwise, use the path-based approach (works for both prod and demo with paths)
        downloadUrl = await this.getAttachmentDownloadUrl(attachmentPath);
      }
  
      // Fetch the file
      const response = await fetch(downloadUrl);
      if (!response.ok) throw new Error('Download failed');
  
      // Get the blob from the response
      const blob = await response.blob();
  
      // Create object URL for the blob
      const objectUrl = window.URL.createObjectURL(blob);
  
      // Create and trigger download
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = attachment.name || attachment.filename || 'download'; // Fallback filename
      document.body.appendChild(link);
      link.click();
  
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('[API] Failed to download attachment:', error);
      throw error;
    }
  }

  // Locations
  async getLocations(organizationId) {
    return this.request(`/organization_location?organization_id=${organizationId}`, { method: 'GET' });
  }

  async getOrganizationLocationsPublic(organizationId, { includeProviders = false } = {}) {
    const qp = new URLSearchParams({ organization_id: organizationId });
    if (includeProviders) qp.append('include_providers', 'true');
    return this.publicRequest(`/public/organization-locations?${qp.toString()}`, { method: 'GET' });
  }

  async addLocation(location) {
    return this.request('/organization_location', {
      method: 'POST',
      body: JSON.stringify(location)
    });
  }

  async updateLocation(id, location) {
    return this.request(`/organization_location/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(location)
    });
  }

  async deleteLocation(id) {
    return this.request(`/organization_location/${id}`, { method: 'DELETE' });
  }

  // Organization
  async updateOrganization(organizationId, data) {
    return this.request(`/organization/${organizationId}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async getOrganization(organizationId) {
    return this.request(`/organization/${organizationId}`, { method: 'GET' });
  }

  async getOrganizationPublic(organizationId) {
    return this.publicRequest(`/public/organizations/${organizationId}`, { method: 'GET' });
  }

  async getOrganizationLocations(organizationId) {
    return this.request(`/organization-locations?organization_id=${organizationId}`, { method: 'GET' });
  }

  async getOrganizationForms(organizationId) {
    return this.request(`/organization-forms?organization_id=${organizationId}`, { method: 'GET' });
  }

  async updateUserSolutionSettings(userSolutionId, currentUserSolution, newSettings) {
    const updatedUserSolution = {
      ...currentUserSolution,
      settings: {
        ...currentUserSolution.settings,
        ...newSettings
      }
    };

    return this.request(`/user_solution/${userSolutionId}`, {
      method: 'PATCH',
      body: JSON.stringify(updatedUserSolution)
    });
  }

  // Public Form Methods
  async getPublishedForm(idOrSlug) {
    try {
      let form = null;

      try {
        form = await this.publicRequest(`/public/forms/${idOrSlug}`, { method: 'GET' });
      } catch (error) {
        // Silent fail, form might not exist
      }

      if (!form || form.status !== 'published') {
        return null;
      }

      if (!form.current_version_id) {
        return null;
      }

      const version = await this.publicRequest(`/public/form-versions/${form.current_version_id}`, { method: 'GET' });

      return {
        ...form,
        ...version.definition
      };
    } catch (error) {
      console.error('[API] Failed to fetch published form:', error);
      return null;
    }
  }

  async submitFormResponse(responseData) {
    return this.publicRequest('/public/form-responses-development', {
      method: 'POST',
      body: JSON.stringify({
        ...responseData,
        created_at: Date.now(),
        status: responseData.status || 'complete'
      })
    });
  }

  async submitFormResponseWithSession(responseData, generateSession = false) {
    const payload = {
      ...responseData,
      created_at: Date.now(),
      status: responseData.status || 'complete'
    };

    // Add session token generation flag
    if (generateSession) {
      payload.generate_session = true;
    }

    try {
      const result = await this.publicRequest('/public/form-responses-development', {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      return result;
    } catch (error) {
      console.error('[API] Failed to submit form response with session:', error);
      throw error;
    }
  }

  async generateFormSession() {
    return this.publicRequest('/public/generate-session', {
      method: 'POST',
      body: JSON.stringify({
        timestamp: Date.now()
      })
    });
  }

  async uploadFormAttachment(file, questionId, sessionToken, onProgress = null) {
    // Helper to convert file to base64
    const fileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    };

    const base64Data = await fileToBase64(file);

    return this.publicRequest('/public/upload-attachment', {
      method: 'POST',
      body: JSON.stringify({
        file_data: base64Data,
        file_name: file.name,
        file_type: file.type,
        file_size: file.size,
        question_id: questionId,
        session_token: sessionToken
      })
    });
  }

  // Recent Activity
  async getRecentActivities(organizationId, locationId = null, before = null, limit = 10) {
    let endpoint = `/recent_activity?organization_id=${organizationId}&solution_id=1`;
    if (locationId) endpoint += `&location_id=${locationId}`;
    if (before) endpoint += `&before=${before}`;

    return this.request(endpoint, { method: 'GET' });
  }

  async logActivity(userId, organizationId, locationId, activityType, entityType, entityId, description, metadata, status, link) {
    return this.request('/recent_activity', {
      method: 'POST',
      body: JSON.stringify({
        user_id: userId,
        organization_id: organizationId,
        location_id: locationId,
        activity_type: activityType,
        entity_type: entityType,
        entity_id: entityId,
        description,
        metadata,
        status,
        link,
        visibility: null,
        solution_id: 1
      })
    });
  }

  // Support Requests
  async createSupportRequest(requestData) {
    // Helper function for file conversion
    const fileToDataURL = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    let attachments = [];
    if (requestData.attachments?.length) {
      attachments = await Promise.all(
        requestData.attachments.map(file => fileToDataURL(file))
      );
    }

    const payload = {
      user_id: requestData.user_id,
      organization_id: requestData.organization_id,
      type: requestData.type,
      priority: requestData.priority,
      subject: requestData.subject,
      description: requestData.description,
      status: 'Open',
      raw_attachments: attachments
    };

    if (requestData.solution_id) payload.solution_id = requestData.solution_id;
    if (requestData.location_id) payload.location_id = requestData.location_id;

    const request = await this.request('/support_request', {
      method: 'POST',
      body: JSON.stringify(payload)
    });

    // Log activity
    await this.logActivity(
      requestData.user_id,
      requestData.organization_id,
      requestData.location_id || null,
      'SUPPORT_REQUEST',
      'support',
      request.id,
      `Support request created: ${request.subject}`,
      {
        priority: request.priority,
        type: request.type,
        solution_id: request.solution_id || null
      },
      'completed',
      '/support'
    );

    return request;
  }

  async getSupportRequests(userId) {
    return this.request(`/support_request?user_id=${userId}`, { method: 'GET' });
  }

  // Feedback
  async getFeedback(organizationId) {
    return this.request(`/guidept_feedback?organization_id=${organizationId}`, { method: 'GET' });
  }

  async submitFeedback(feedback) {
    return this.request('/guidept_feedback', {
      method: 'POST',
      body: JSON.stringify({
        ...feedback,
        status: 'pending'
      })
    });
  }

  // Patient Verification (public endpoints)
  async verifyPatientByDob(firstName, lastName, dob, formId, ipAddress, verificationMethod, verificationFactor) {
    return this.publicRequest('/patient/verify-dob', {
      method: 'POST',
      body: JSON.stringify({
        first_name: firstName,
        last_name: lastName,
        dob: dob,
        form_id: formId,
        ip_address: ipAddress,
        verification_method: verificationMethod,
        verification_factor: verificationFactor
      })
    });
  }

  async createPatientPublic(patientData) {  // Different from existing createPatient
    return this.publicRequest('/public/patient', {
      method: 'POST',
      body: JSON.stringify({
        first_name: patientData.firstName,
        last_name: patientData.lastName,
        birthday: patientData.dob,
        organization_id: patientData.organizationId,
        phone: patientData.phone,
        email: patientData.email,
        verification_id: patientData.verification_id || null,
        security_question: patientData.securityQuestion || null,
        security_answer: patientData.securityAnswer || null
      })
    });
  }

  async sendVerificationCode(verificationId, method) {
    return this.publicRequest('/patient/send-verification-code', {
      method: 'POST',
      body: JSON.stringify({
        verification_id: verificationId,
        method: method
      })
    });
  }

  async verifyCode(verificationId, code, method) {
    return this.publicRequest('/patient/verify-code', {
      method: 'POST',
      body: JSON.stringify({
        verification_id: verificationId,
        code: code,
        method: method
      })
    });
  }

  // Add these methods to your existing ApiService class in src/services/api.js

  // ============ Encounters ============

  async createEncounter(encounterData) {
    return this.request('/encounter', {
      method: 'POST',
      body: JSON.stringify(encounterData)
    }, 'createEncounter');
  }

  async getEncounters(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.provider_id) queryParams.append('provider_id', filters.provider_id);
    if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
    if (filters.location_id) queryParams.append('location_id', filters.location_id);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.encounter_type) queryParams.append('encounter_type', filters.encounter_type);
    if (filters.start_date) queryParams.append('start_date', filters.start_date);
    if (filters.end_date) queryParams.append('end_date', filters.end_date);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);

    return this.request(`/encounter?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getEncounter(id) {
    return this.request(`/encounter/${id}`, {
      method: 'GET'
    });
  }

  async updateEncounter(id, data) {
    return this.request(`/encounter/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    }, 'updateEncounter');
  }

  async deleteEncounter(id) {
    return this.request(`/encounter/${id}`, {
      method: 'DELETE'
    }, 'deleteEncounter');
  }

  async updateEncounterStatus(id, status) {
    return this.request(`/encounter/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status })
    }, 'updateEncounterStatus');
  }

  // ============ Clinical Notes ============

  async createClinicalNote(noteData) {
    return this.request('/clinical_note', {
      method: 'POST',
      body: JSON.stringify(noteData)
    }, 'createClinicalNote');
  }

  async getClinicalNotes(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.provider_id) queryParams.append('provider_id', filters.provider_id);
    if (filters.encounter_id) queryParams.append('encounter_id', filters.encounter_id);
    if (filters.note_type) queryParams.append('note_type', filters.note_type);
    if (filters.signed !== undefined) queryParams.append('signed', String(filters.signed));
    if (filters.start_date) queryParams.append('start_date', filters.start_date);
    if (filters.end_date) queryParams.append('end_date', filters.end_date);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);

    return this.request(`/clinical_note?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getClinicalNote(id) {
    return this.request(`/clinical_note/${id}`, {
      method: 'GET'
    });
  }

  async updateClinicalNote(id, data) {
    return this.request(`/clinical_note/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    }, 'updateClinicalNote');
  }

  async signClinicalNote(id, signature) {
    return this.request(`/clinical_note/${id}/sign`, {
      method: 'PATCH',
      body: JSON.stringify({
        signature,
        signed_at: new Date().toISOString(),
        attestation: 'I attest that this clinical note is accurate and complete to the best of my knowledge.',
        signed: true
      })
    }, 'signClinicalNote');
  }

  async addClinicalNoteAddendum(id, addendum) {
    return this.request(`/clinical_note/${id}/addendum`, {
      method: 'POST',
      body: JSON.stringify(addendum)
    }, 'addClinicalNoteAddendum');
  }

  // ============ Import Helpers ============

  async getPatientForms(patientId) {
    return this.request(`/form-responses?patient_identifier=${patientId}`, {
      method: 'GET'
    });
  }

  async getPatientReports(patientId) {
    return this.request(`/form-generated-reports?patient_id=${patientId}`, {
      method: 'GET'
    });
  }

  async getEncountersByPatient(patientId, status = null) {
    const filters = { patient_id: patientId };
    if (status) filters.status = status;
    return this.getEncounters(filters);
  }

  // ============ Vitals ============

  async saveVitals(encounterId, vitals) {
    return this.request(`/encounter/${encounterId}/vitals`, {
      method: 'POST',
      body: JSON.stringify(vitals)
    }, 'saveVitals');
  }


  // ============ Provider Availability Management ============

  async createProviderAvailability(data) {
    return this.request('/provider_availability', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getProviderAvailability(providerId, { locationId } = {}) {
    const qp = new URLSearchParams({ provider_id: providerId });
    if (locationId) qp.append('location_id', locationId);
    return this.request(`/provider_availability?${qp.toString()}`, {
      method: 'GET'
    });
  }
  async getProviderAvailabilityPublic(providerId, { locationId, organizationId } = {}) {
    const qp = new URLSearchParams({ provider_id: providerId });
    if (organizationId) qp.append('organization_id', organizationId);
    if (locationId) qp.append('location_id', locationId);
    return this.publicRequest(`/public/provider-availability?${qp.toString()}`, {
      method: 'GET'
    });
  }

  async getScheduleOverridesPublic(providerIds, startDate, endDate, { organizationId } = {}) {
    const params = new URLSearchParams({ provider_id: providerIds });
    if (organizationId) params.set('organization_id', organizationId);
    if (startDate) params.set('start_date', startDate);
    if (endDate) params.set('end_date', endDate);
    return this.publicRequest(`/public/schedule-overrides?${params.toString()}`, {
      method: 'GET'
    });
  }

  async updateProviderAvailability(id, data) {
    return this.request(`/provider_availability/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteProviderAvailability(id) {
    return this.request(`/provider_availability/${id}`, {
      method: 'DELETE'
    });
  }

  // Get availability for multiple providers
  async getProvidersAvailability(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.provider_ids) queryParams.append('provider_ids', filters.provider_ids.join(','));
    if (filters.location_id) queryParams.append('location_id', filters.location_id);
    if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
    if (filters.is_active !== undefined) queryParams.append('is_active', filters.is_active);

    return this.request(`/provider_availability?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  // ============ Available Slots ============

  async getAvailableSlots(query) {
    const queryParams = new URLSearchParams();

    if (query.provider_id) queryParams.append('provider_id', query.provider_id);
    if (query.provider_ids) queryParams.append('provider_ids', query.provider_ids.join(','));
    if (query.location_id) queryParams.append('location_id', query.location_id);
    queryParams.append('start_date', query.start_date);
    queryParams.append('end_date', query.end_date);
    if (query.appointment_type) queryParams.append('appointment_type', query.appointment_type);
    if (query.appointment_duration_minutes) queryParams.append('duration', query.appointment_duration_minutes);
    if (query.include_flexible !== undefined) queryParams.append('include_flexible', query.include_flexible);

    return this.request(`/available_slot?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  // Check if a specific slot is available
  async checkSlotAvailability(data) {
    return this.request('/check_slot_availability', {
      method: 'POST',
      body: JSON.stringify({
        provider_id: data.provider_id,
        date: data.date,
        start_time: data.start_time,
        end_time: data.end_time,
        appointment_id: data.appointment_id // For rescheduling, exclude current appointment
      })
    });
  }

  // ============ Appointment Types ============

  async createAppointmentType(data) {
    return this.request('/appointment_type', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getAppointmentTypes(organizationId, { locationId } = {}) {
    const qp = new URLSearchParams({ organization_id: organizationId });
    if (locationId) qp.append('location_id', locationId);
    return this.request(`/appointment_type?${qp.toString()}`, {
      method: 'GET'
    });
  }

  async getAppointmentTypesPublic(organizationId, { locationId } = {}) {
    const qp = new URLSearchParams({ organization_id: organizationId, is_active: 'true' });
    if (locationId) qp.append('location_id', locationId);
    return this.publicRequest(`/appointment_types/public?${qp.toString()}`, {
      method: 'GET'
    });
  }

  async updateAppointmentType(id, data) {
    return this.request(`/appointment_type/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteAppointmentType(id) {
    return this.request(`/appointment_type/${id}`, {
      method: 'DELETE'
    });
  }

  // ============ Schedule Overrides ============

  async createScheduleOverride(data) {
    return this.request('/schedule_override', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async getScheduleOverrides(providerId, startDate, endDate) {
    const queryParams = new URLSearchParams({ provider_id: providerId });
    if (startDate) queryParams.set('start_date', startDate);
    if (endDate) queryParams.set('end_date', endDate);

    return this.request(`/schedule_override?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async updateScheduleOverride(id, data) {
    return this.request(`/schedule_override/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async deleteScheduleOverride(id) {
    return this.request(`/schedule_override/${id}`, {
      method: 'DELETE'
    });
  }

  // Quick actions for schedule management
  async quickScheduleAction(action) {
    return this.request('/schedule_quick_action', {
      method: 'POST',
      body: JSON.stringify(action)
    });
  }

  // ============ Enhanced Appointment Methods ============

  async createAppointment(appointmentData) {
    return this.request('/appointment', {
      method: 'POST',
      body: JSON.stringify(appointmentData)
    });
  }

  async getAppointments(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.provider_id) queryParams.append('provider_id', filters.provider_id);
    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.location_id) queryParams.append('location_id', filters.location_id);
    if (filters.start_date) queryParams.append('start_date', filters.start_date);
    if (filters.end_date) queryParams.append('end_date', filters.end_date);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.appointment_type) queryParams.append('appointment_type', filters.appointment_type);
    if (filters.is_telehealth !== undefined) queryParams.append('is_telehealth', filters.is_telehealth);

    return this.request(`/appointment?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getAppointmentsPublic(data) {
    const qp = new URLSearchParams({
      provider_id: data.provider_id,
      organization_id: data.organization_id,
      start_date: data.date_range.start,
      end_date: data.date_range.end
    });
    if (data.location_id) qp.append('location_id', data.location_id);
    return this.publicRequest(`/appointments/public?${qp.toString()}`, {
      method: 'GET'
    });
  }

  async getAppointment(id) {
    return this.request(`/appointment/${id}`, {
      method: 'GET'
    });
  }

  async updateAppointment(id, data) {
    return this.request(`/appointment/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async cancelAppointment(id, reason) {
    return this.request(`/appointment/cancel/${id}`, {
      method: 'POST',
      body: JSON.stringify({
        cancellation_reason: reason,
        cancelled_at: Date.now()
      })
    });
  }

  async confirmAppointment(id) {
    return this.request(`/appointment/${id}/confirm`, {
      method: 'POST',
      body: JSON.stringify({
        confirmed_at: Date.now()
      })
    });
  }

  async markAppointmentNoShow(id) {
    return this.request(`/appointment/${id}/no_show`, {
      method: 'POST',
      body: JSON.stringify({
        status: 'no_show',
        updated_at: Date.now()
      })
    });
  }

  async rescheduleAppointment(id, newSchedule) {
    return this.request(`/appointment/${id}/reschedule`, {
      method: 'POST',
      body: JSON.stringify({
        appointment_date: newSchedule.date,
        start_time: newSchedule.start_time,
        end_time: newSchedule.end_time,
        rescheduled_at: Date.now()
      })
    });
  }

  // ============ Patient Self-Scheduling ============

  // Request appointment (for approval-based scheduling)
  async requestAppointment(data) {
    return this.request('/appointment_request', {
      method: 'POST',
      body: JSON.stringify({
        ...data,
        status: 'pending_approval',
        requested_at: Date.now()
      })
    });
  }

  // Get pending appointment requests for a provider
  async getPendingAppointmentRequests(providerId) {
    return this.request(`/appointment?provider_id=${providerId}&status=pending_approval`, {
      method: 'GET'
    });
  }

  // Approve appointment request
  async approveAppointmentRequest(appointmentId, adjustments = {}) {
    return this.request(`/appointment/${appointmentId}/approve`, {
      method: 'POST',
      body: JSON.stringify({
        status: 'confirmed',
        approved_at: Date.now(),
        ...adjustments // Allow provider to adjust time if needed
      })
    });
  }

  // Decline appointment request with reason
  async declineAppointmentRequest(appointmentId, reason) {
    return this.request(`/appointment/${appointmentId}/decline`, {
      method: 'POST',
      body: JSON.stringify({
        status: 'declined',
        declined_at: Date.now(),
        decline_reason: reason
      })
    });
  }

  // ============ Form-to-Patient Mapping ============

  async createFormPatientMapping(formId, mappings) {
    return this.request('/form_patient_mapping', {
      method: 'POST',
      body: JSON.stringify({
        form_id: formId,
        mappings: mappings,
        created_at: Date.now()
      })
    });
  }

  async getFormPatientMapping(formId) {
    return this.request(`/form_patient_mapping?form_id=${formId}`, {
      method: 'GET'
    });
  }

  async updateFormPatientMapping(id, mappings) {
    return this.request(`/form_patient_mapping/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        mappings: mappings,
        updated_at: Date.now()
      })
    });
  }

  // Process form submission to create/update patient
  async processFormToPatient(formResponseId) {
    return this.request('/process_form_to_patient', {
      method: 'POST',
      body: JSON.stringify({
        form_response_id: formResponseId,
        processed_at: Date.now()
      })
    });
  }

  // ============ Patient Update Queue ============

  async getPendingPatientUpdates(patientId) {
    return this.request(`/pending_patient_update?patient_id=${patientId}&status=pending`, {
      method: 'GET'
    });
  }

  async approvePatientUpdate(updateId) {
    return this.request(`/pending_patient_update/${updateId}/approve`, {
      method: 'POST',
      body: JSON.stringify({
        status: 'approved',
        reviewed_at: Date.now()
      })
    });
  }

  async rejectPatientUpdate(updateId, reason) {
    return this.request(`/pending_patient_update/${updateId}/reject`, {
      method: 'POST',
      body: JSON.stringify({
        status: 'rejected',
        review_notes: reason,
        reviewed_at: Date.now()
      })
    });
  }

  // ============ Provider Schedule Summary ============

  async getProviderScheduleSummary(providerId, date) {
    return this.request(`/provider_schedule_summary?provider_id=${providerId}&date=${date}`, {
      method: 'GET'
    });
  }

  async getOrganizationScheduleSummary(organizationId, date) {
    return this.request(`/organization_schedule_summary?organization_id=${organizationId}&date=${date}`, {
      method: 'GET'
    });
  }

  // ============ Patient Matching for Scheduling Forms ============

  async findExistingPatient(data) {
    // Match on first_name + last_name + date_of_birth + (phone OR email)
    return this.request('/patient_match', {
      method: 'POST',
      body: JSON.stringify({
        first_name: data.firstName,
        last_name: data.lastName,
        date_of_birth: data.dob,
        phone: data.phone,
        email: data.email,
        organization_id: data.organizationId
      })
    });
  }

  // Create or update patient from form submission
  async createOrUpdatePatientFromForm(formResponseId) {
    return this.request('/patient_from_form', {
      method: 'POST',
      body: JSON.stringify({
        form_response_id: formResponseId,
        created_at: Date.now()
      })
    });
  }
  // search patients
  async searchPatients(params) {
    const queryParams = new URLSearchParams();

    if (params.search_term) {
      queryParams.append('search_term', params.search_term);
    }

    if (params.organization_id) {
      queryParams.append('organization_id', params.organization_id);
    }

    // Optional: Add pagination support
    if (params.limit) {
      queryParams.append('limit', params.limit);
    }

    if (params.offset) {
      queryParams.append('offset', params.offset);
    }

    return this.request(`/search_patients?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  // ============ Messaging System ============
  // Add these methods to your existing ApiService class in src/services/api.js

  // Thread Management
  async getMessageThreads(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.sender_id) queryParams.append('sender_id', filters.sender_id);
    if (filters.category?.length) filters.category.forEach(cat => queryParams.append('category', cat));
    if (typeof (filters?.status) == 'array' && filters.status?.length > 0) filters.status.forEach(stat => queryParams.append('status', stat));
    if (filters.priority?.length) filters.priority.forEach(pri => queryParams.append('priority', pri));
    if (filters.assigned_to_me) queryParams.append('assigned_to_me', filters.assigned_to_me);
    if (filters.unread_only) queryParams.append('unread_only', filters.unread_only);
    if (filters.has_attachments) queryParams.append('has_attachments', filters.has_attachments);
    if (filters.requires_action) queryParams.append('requires_action', filters.requires_action);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit || 20);
    if (filters.sort_by) queryParams.append('sort_by', filters.sort_by || 'last_message_at');
    if (filters.sort_direction) queryParams.append('sort_direction', filters.sort_direction || 'desc');

    return this.request(`/message_thread?${queryParams.toString()}`, {
      method: 'GET'
    }, 'getMessageThreads');
  }

  async getMessageThread(threadId) {
    return this.request(`/message_thread/${threadId}`, {
      method: 'GET'
    }, 'getMessageThread');
  }

  async createMessageThread(threadData) {
    return this.request('/message_thread', {
      method: 'POST',
      body: JSON.stringify({
        patient_id: threadData.patient_id,
        patient_name: threadData.patient_name,
        last_message_at: threadData.last_message_at || Date.now(),
        sender_id: threadData.sender_id,
        sender_name: threadData.sender_name,
        last_message_preview: threadData.last_message_preview,
        last_sender_name: threadData.last_sender_name,
        subject: threadData.subject,
        category: threadData.category || 'general',
        priority: threadData.priority || 'medium',
        participants: threadData.participants || [],
        initial_message: threadData.initial_message,
        created_at: Date.now(),
        status: 'open'
      })
    }, 'createMessageThread');
  }

  async updateMessageThread(threadId, updates) {
    return this.request(`/message_thread/${threadId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        ...updates,
        updated_at: Date.now()
      })
    }, 'updateMessageThread');
  }

  async archiveMessageThread(threadId) {
    return this.updateMessageThread(threadId, {
      status: 'archived',
      archived_at: Date.now()
    });
  }

  async closeMessageThread(threadId) {
    return this.updateMessageThread(threadId, {
      status: 'closed',
      closed_at: Date.now()
    });
  }

  // Thread Participants
  async getThreadParticipants(threadId) {
    return this.request(`/message_thread/${threadId}/participants`, {
      method: 'GET'
    }, 'getThreadParticipants');
  }

  async addThreadParticipant(threadId, userId, role = 'staff') {
    return this.request(`/message_thread/${threadId}/participants`, {
      method: 'POST',
      body: JSON.stringify({
        user_id: userId,
        role: role,
        joined_at: Date.now(),
        notification_preference: 'all'
      })
    }, 'addThreadParticipant');
  }

  async removeThreadParticipant(threadId, userId) {
    return this.request(`/message_thread/${threadId}/participants/${userId}`, {
      method: 'DELETE'
    }, 'removeThreadParticipant');
  }

  // Messages
  async getMessages(threadId, pagination = {}) {
    const queryParams = new URLSearchParams();
    if (pagination.page) queryParams.append('thread_id', threadId);
    if (pagination.page) queryParams.append('page', pagination.page);
    if (pagination.limit) queryParams.append('limit', pagination.limit || 50);
    if (pagination.before) queryParams.append('before', pagination.before);
    if (pagination.after) queryParams.append('after', pagination.after);

    return this.request(`/message_thread/${threadId}/messages?${queryParams.toString()}`, {
      method: 'GET'
    }, 'getMessages');
  }

  async sendMessage(threadId, messageData) {
    return this.request(`/message`, {
      method: 'POST',
      body: JSON.stringify({
        thread_id: threadId,
        sender_id: messageData.sender_id,
        sender_name: messageData.sender_name,
        body: messageData.body,
        body_format: messageData.body_format || 'plain',
        is_urgent: messageData.is_urgent || false,
        requires_response: messageData.requires_response || false,
        response_deadline: messageData.response_deadline,
        parent_message_id: messageData.parent_message_id,
        attachments: messageData.attachments || [],
        mentioned_user_ids: messageData.mentioned_user_ids || [],
        created_at: Date.now(),
        delivery_status: 'pending'
      })
    }, 'sendMessage');
  }

  async updateMessage(messageId, updates) {
    return this.request(`/message/${messageId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        ...updates,
        updated_at: Date.now()
      })
    }, 'updateMessage');
  }

  async editMessage(messageId, content) {
    return this.request(`/message/${messageId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        body: content,
        edited: true,
        edited_at: Date.now(),
        original_body: content
      })
    }, 'editMessage');
  }

  async deleteMessage(messageId) {
    return this.request(`/message/${messageId}`, {
      method: 'DELETE'
    }, 'deleteMessage');
  }

  async markMessageRead(messageId) {
    return this.request(`/message/${messageId}/read`, {
      method: 'POST',
      body: JSON.stringify({
        read_at: Date.now()
      })
    }, 'markMessageRead');
  }

  async markThreadRead(threadId) {
    return this.request(`/message_thread/${threadId}/read`, {
      method: 'POST',
      body: JSON.stringify({
        read_at: Date.now()
      })
    }, 'markThreadRead');
  }

  // Update participant's read status
  async updateParticipantReadStatus(threadId, userId, lastMessageId) {
    return this.request(`/message_thread/${threadId}/participants/${userId}/read`, {
      method: 'PATCH',
      body: JSON.stringify({
        last_read_at: Date.now(),
        last_read_message_id: lastMessageId
      })
    }, 'updateParticipantReadStatus');
  }

  // Get unread thread count for a user
  async getUnreadThreadCount(userId) {
    return this.request(`/message_thread/unread-count?user_id=${userId}`, {
      method: 'GET'
    }, 'getUnreadThreadCount');
  }

  // Thread Actions & Assignment
  async assignThread(threadId, userId) {
    return this.updateMessageThread(threadId, {
      assigned_to: userId,
      assigned_at: Date.now()
    });
  }

  async setThreadPriority(threadId, priority) {
    return this.updateMessageThread(threadId, { priority });
  }

  async setThreadCategory(threadId, category) {
    return this.updateMessageThread(threadId, { category });
  }

  // Search
  async searchMessages(query, filters = {}) {
    const queryParams = new URLSearchParams();

    queryParams.append('q', query);
    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.thread_id) queryParams.append('thread_id', filters.thread_id);
    if (filters.category) queryParams.append('category', filters.category);
    if (filters.date_from) queryParams.append('date_from', filters.date_from);
    if (filters.date_to) queryParams.append('date_to', filters.date_to);
    if (filters.limit) queryParams.append('limit', filters.limit || 20);

    return this.request(`/messages/search?${queryParams.toString()}`, {
      method: 'GET'
    }, 'searchMessages');
  }

  async searchThreads(query, filters = {}) {
    const queryParams = new URLSearchParams();

    queryParams.append('q', query);
    if (filters.patient_id) queryParams.append('patient_id', filters.patient_id);
    if (filters.category) queryParams.append('category', filters.category);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.limit) queryParams.append('limit', filters.limit || 20);

    return this.request(`/message_thread/search?${queryParams.toString()}`, {
      method: 'GET'
    }, 'searchThreads');
  }

  // Unread counts
  async getUnreadMessageCount(userId) {
    return this.request(`/message/unread-count?user_id=${userId}`, {
      method: 'GET'
    }, 'getUnreadMessageCount');
  }

  async getUnreadThreadsCount(userId) {
    return this.request(`/message_threads/unread-count?user_id=${userId}`, {
      method: 'GET'
    }, 'getUnreadThreadsCount');
  }



  async getMessageAttachments(messageId) {
    return this.request(`/message_attachment?message_id=${messageId}`, {
      method: 'GET'
    }, 'getMessageAttachments');
  }

  async getThreadAttachments(threadId) {
    return this.request(`/message_attachment?thread_id=${threadId}`, {
      method: 'GET'
    }, 'getThreadAttachments');
  }

  async deleteMessageAttachment(attachmentId) {
    return this.request(`/message_attachment/${attachmentId}`, {
      method: 'DELETE'
    }, 'deleteMessageAttachment');
  }

  // ============ UPDATED MESSAGE SENDING WITH ATTACHMENTS ============
  // This is how to handle attachments when sending a message

  async sendMessageWithAttachments(threadId, messageData, files = []) {
    try {
      // Step 1: Create the message
      const messageResponse = await apiService.sendMessage(threadId, {
        thread_id: threadId,
        sender_id: messageData.sender_id,
        sender_name: messageData.sender_name,
        body: messageData.body,
        body_format: messageData.body_format || 'plain',
        is_urgent: messageData.is_urgent || false,
        requires_response: messageData.requires_response || false,
        response_deadline: messageData.response_deadline,
        created_at: Date.now(),
        delivery_status: 'pending',
        // Don't include attachments here yet
        contains_attachments: files.length > 0
      });

      // Step 2: Upload attachments and link to message
      if (files.length > 0) {
        const attachmentPromises = files.map(file =>
          apiService.uploadMessageAttachment(file, messageResponse.id, threadId)
        );

        const attachmentResults = await Promise.all(attachmentPromises);

        // Step 3: Update message with attachment IDs (optional, depending on your schema)
        // You might store attachment IDs in the message record for quick access
        await apiService.updateMessage(messageResponse.id, {
          attachment_ids: attachmentResults.map(a => a.id)
        });
      }

      return messageResponse;
    } catch (error) {
      console.error('Error sending message with attachments:', error);
      throw error;
    }
  }

  // ============ Video Sessions ============


  async getVideoSession(sessionId) {
    return this.request(`/video_session/${sessionId}`, {
      method: 'GET'
    }, 'getVideoSession');
  }

  async getVideoSessionByAppointment(appointmentId) {
    return this.request(`/video_session?appointment_id=${appointmentId}`, {
      method: 'GET'
    }, 'getVideoSessionByAppointment');
  }

  async startVideoSession(sessionId) {
    return this.request(`/video_session/${sessionId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        status: 'active',
        actual_start: Date.now(),
        provider_joined_at: Date.now()
      })
    }, 'startVideoSession');
  }

  async endVideoSession(sessionId) {
    const now = Date.now();
    return this.request(`/video_session/${sessionId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        status: 'completed',
        actual_end: now,
        provider_left_at: now
      })
    }, 'endVideoSession');
  }

  async updateVideoSession(sessionId, data) {
    return this.request(`/video_session/${sessionId}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    }, 'updateVideoSession');
  }

  async validateFormRedirect(sourceFormId, targetFormId, organizationId) {
    // Prevent self-redirect
    if (sourceFormId === targetFormId) {
      return {
        isValid: false,
        error: 'Forms cannot redirect to themselves'
      };
    }

    try {
      // Get target form to check if it redirects back to source
      const targetForm = await this.getFormDefinition(targetFormId);

      // Cast to any to access the new properties safely
      const formSettings = targetForm?.settings?.form;

      if (formSettings?.redirectType === 'form' &&
        formSettings?.formRedirect?.targetFormId === sourceFormId) {
        return {
          isValid: false,
          error: 'Circular redirect detected - target form redirects back to this form'
        };
      }

      return { isValid: true };
    } catch (error) {
      console.error('[API] Error validating form redirect:', error);
      return {
        isValid: false,
        error: 'Unable to validate redirect configuration'
      };
    }
  }

  getQuestionTypeCompatibility(sourceType, targetType) {
    // Define compatible question type mappings
    const compatibilityMap = {
      'text': ['text', 'textarea', 'email', 'phone'],
      'textarea': ['text', 'textarea'],
      'email': ['text', 'textarea', 'email'],
      'phone': ['text', 'textarea', 'phone'],
      'number': ['number', 'text', 'textarea'],
      'date': ['date', 'dateTime', 'text', 'textarea'],
      'dateTime': ['date', 'dateTime', 'text', 'textarea'],
      'multipleChoice': ['multipleChoice', 'select', 'text', 'textarea'],
      'checkbox': ['checkbox', 'multipleChoice', 'select'],
      'select': ['select', 'multipleChoice', 'text', 'textarea'],
      'signature': ['signature'],
      'fileUpload': ['fileUpload'],
      'bodyDiagram': ['bodyDiagram'],
      'address': ['address', 'textarea'],
      'entryAndDropdown': ['entryAndDropdown', 'text', 'textarea'],
      'doubleEntry': ['doubleEntry', 'text', 'textarea'],
      'displayText': [], // Cannot be mapped to
      'imageAndText': [] // Cannot be mapped to
    };

    const compatibleTypes = compatibilityMap[sourceType] || [];
    return compatibleTypes.includes(targetType);
  }

  // ========================== Documents ==========================
  async getDocumentCategories(organizationId) {
    return this.request(`/document_category?organization_id=${organizationId}`, {
      method: 'GET'
    });
  }

  async createDocumentCategory(categoryData) {
    return this.request('/document_category', {
      method: 'POST',
      body: JSON.stringify(categoryData)
    });
  }

  async uploadPatientDocument(documentData, file) {
    // Convert file to base64 (following the uploadFormAttachment pattern)
    const fileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    };

    const base64Data = await fileToBase64(file);

    return this.request('/patient_document', {
      method: 'POST',
      body: JSON.stringify({
        patient_id: documentData.patient_id,
        category_id: documentData.category_id,
        document_name: documentData.name,
        description: documentData.description || '',
        document_date: documentData.document_date || '',
        provider_name: documentData.provider_name || '',
        file_data: base64Data,
        file_name: file.name,
        file_type: file.type,
        file_size: file.size
      })
    });
  }


  // Patient Documents
  async getPatientDocuments(patientId, categoryId = null) {
    let endpoint = `/patient_document?patient_id=${patientId}`;
    if (categoryId) endpoint += `&category_id=${categoryId}`;

    return this.request(endpoint, {
      method: 'GET'
    });
  }

  async deletePatientDocument(documentId) {
    return this.request(`/patient_document/${documentId}`, {
      method: 'DELETE'
    });
  }

  // Get most recent encounter with vitals for a patient
  async getPatientRecentVitals(patientId) {
    const encounters = await this.request(
      `/encounter?patient_id=${patientId}&has_vitals=true&limit=1&sort_by=encounter_date&sort_direction=desc`,
      { method: 'GET' }
    );
    return encounters[0]?.vitals || null;
  }

  // Get upcoming appointments
  async getUpcomingAppointments(patientId, limit = 5) {
    const now = new Date().toISOString();
    return this.request(
      `/appointment?patient_id=${patientId}&start_after=${now}&status=scheduled,confirmed&limit=${limit}&sort_by=start_timestamp&sort_direction=asc`,
      { method: 'GET' }
    );
  }

  // Get patient's existing message threads (for thread selection)
  async getPatientMessageThreads(patientId, limit = 5) {
    return this.request(
      `/message_thread?patient_id=${patientId}&status=open&limit=${limit}&sort_by=last_message_at&sort_direction=desc`,
      { method: 'GET' }
    );
  }

  // =========================== Billing and Invoices ===========================
  async getInvoices(filters = {}) {
    const queryParams = new URLSearchParams();

    if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.start_date) queryParams.append('start_date', filters.start_date);
    if (filters.end_date) queryParams.append('end_date', filters.end_date);
    if (filters.provider_id) queryParams.append('provider_id', filters.provider_id);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);

    return this.request(`/billing/invoices?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getBillingBalance() {
    return this.request('/billing/balance', {
      method: 'GET'
    });
  }

  async getBillingTransactions(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);

    return this.request(`/billing/transactions?${queryParams.toString()}`, {
      method: 'GET'
    });
  }

  async getServicePackages(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
    if (filters.active !== undefined) queryParams.append('active', filters.active);
    
    return this.request(`/service_package?${queryParams.toString()}`, {
      method: 'GET'
    });
  }
  
  async createServicePackage(packageData) {
    return this.request('/service_package', {
      method: 'POST',
      body: JSON.stringify(packageData)
    });
  }

  async updateServicePackage(id, updates) {
    return this.request(`/service_package/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(updates)
    });
  }

  async deleteServicePackage(id) {
    return this.request(`/service_package/${id}`, {
      method: 'DELETE'
    });
  }

  // ============ Patient Packages ============ / 

async getPatientPackages(patientId, includeExpired = false) {
  const queryParams = new URLSearchParams();
  queryParams.append('patient_id', patientId);
  if (includeExpired) queryParams.append('include_expired', 'true');
  
  return this.request(`/patient_package?${queryParams.toString()}`, {
    method: 'GET'
  });
}

async purchasePackage(purchaseData) {
  return this.request('/patient-packages/purchase', {
    method: 'POST',
    body: JSON.stringify(purchaseData)
  });
}

// Not using
async applyPackageCredits(creditData) {
  return this.request('/patient-packages/apply-credits', {
    method: 'POST',
    body: JSON.stringify(creditData)
  });
}

// ============ Subscription Plans ============

async getSubscriptionPlans(filters = {}) {
  const queryParams = new URLSearchParams();
  if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
  if (filters.active !== undefined) queryParams.append('active', filters.active);
  if (filters.plan_type) queryParams.append('plan_type', filters.plan_type);
  
  return this.request(`/subscription_plan?${queryParams.toString()}`, {
    method: 'GET'
  });
}

async createSubscriptionPlan(planData) {
  return this.request('/subscription_plan', {
    method: 'POST',
    body: JSON.stringify(planData)
  });
}

async updateSubscriptionPlan(id, updates) {
  return this.request(`/subscription_plan/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(updates)
  });
}

// ============ Patient Subscriptions ============

async getPatientSubscriptions(patientId, activeOnly = true) {
  const queryParams = new URLSearchParams();
  queryParams.append('patient_id', patientId);
  if (activeOnly) queryParams.append('status', 'active');
  
  return this.request(`/payment_plan?${queryParams.toString()}`, {
    method: 'GET'
  });
}

async subscribePatient(subscriptionData) {
  return this.request('/patient-subscriptions/subscribe', {
    method: 'POST',
    body: JSON.stringify(subscriptionData)
  });
}

async cancelPatientSubscription(subscriptionId, cancelAtPeriodEnd = true) {
  return this.request(`/patient-subscriptions/${subscriptionId}/cancel`, {
    method: 'POST',
    body: JSON.stringify({
      cancel_at_period_end: cancelAtPeriodEnd
    })
  });
}

// ============ Credit & Billing Integration ============

async getAvailableCredits(patientId, appointmentTypeId = null) {
  const queryParams = new URLSearchParams();
  queryParams.append('patient_id', patientId);
  if (appointmentTypeId) queryParams.append('appointment_type_id', appointmentTypeId);
  
  return this.request(`/billing/available-credits?${queryParams.toString()}`, {
    method: 'GET'
  });
}

async checkPackagePricing(packageId) {
  return this.request(`/service-packages/${packageId}/pricing`, {
    method: 'GET'
  });
}


  
  





}

const baseApiService = new ApiService();

export const apiService = withAudit(baseApiService);